import * as React from "react";
import styled from "styled-components";

interface ImageSectionProps {
  imageSrc: string;
  imageAlt?: string;
}

const ImageSection: React.FC<ImageSectionProps> = ({
  imageSrc,
  imageAlt = "Interface Image"
}) => {
  return (
    <ImageWrapper>
      <ResponsiveImage src={imageSrc} alt={imageAlt} />
    </ImageWrapper>
  );
};

const ImageWrapper = styled.div`
  flex: 1;
  max-width: 690px;

  @media (max-width: 768px) {
    order: 1;
    margin-left: 0;
    margin-bottom: 32px;
    max-width: 100%;
  }
`;

const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export default ImageSection;
